var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPhoneSlash = function SvgIconPhoneSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.827 3.01a1 1 0 0 1 1.413.067l6.272 6.9.02.021 8.708 9.58a1 1 0 1 1-1.48 1.345l-8.34-9.174a7 7 0 0 0-.553.156L9.35 14.53a1.77 1.77 0 0 1-1.057 1.273l-.01.004-4.43 1.77a1.74 1.74 0 0 1-2.04-.552 5.5 5.5 0 0 1 .46-7.25l.001-.002a13.8 13.8 0 0 1 3.878-2.718L3.76 4.423a1 1 0 0 1 .067-1.413m3.746 5.607a11.8 11.8 0 0 0-3.885 2.572 3.5 3.5 0 0 0-.403 4.461L7.417 14l.517-2.633.003-.015a1.75 1.75 0 0 1 1-1.235zm1.5 1.445h.002l.116.335-.003-.004-.116-.33zm.115.331.215.613-.212-.609m-5.79 5.411-.002-.002z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3 6.727a1 1 0 0 1 1.023-.977 13.75 13.75 0 0 1 9.403 4.024 5.5 5.5 0 0 1 .473 7.235c-.122.17-.278.314-.458.423a1 1 0 0 1-1.116-1.657 3.5 3.5 0 0 0-.314-4.587 11.75 11.75 0 0 0-8.034-3.438 1 1 0 0 1-.977-1.023"
  }))));
};
export default SvgIconPhoneSlash;